const lightStyles = 'skapa-skip-content>a{clip:var(--skapa-skip-content__auto,rect(1px,1px,1px,1px));background:rgb(var(--colour-static-light-grey,245,245,245));border-radius:64px;color:rgb(var(--colour-static-black,17,17,17));font-weight:700;height:var(--skapa-skip-content__auto,1px);margin:-1px;overflow:var(--skapa-skip-content__visible,hidden);padding:1rem 2rem;position:absolute;text-decoration:none;white-space:var(--skapa-skip-content__normal,nowrap);width:var(--skapa-skip-content__auto,1px);z-index:1}skapa-skip-content>a:active,skapa-skip-content>a:focus,skapa-skip-content>a:focus-visible{--skapa-skip-content__auto:auto;--skapa-skip-content__visible:visible;--skapa-skip-content__normal:normal;box-shadow:0 0 0 4px var(--skapa-focus-ring-internal,rgb(var(--colour-neutral-1,255,255,255)));outline:2px solid var(--skapa-focus-ring-external,rgb(var(--colour-neutral-7,17,17,17)));outline-offset:4px;text-decoration:none;transition:outline .2s ease-out,box-shadow .2s ease-out}';
import { SkapaElement } from "@ingka/skapa-webc-element";
function generateTemplate({ html, prefixReplacer }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <slot name="light-styles"></slot>
    <slot></slot>
  `;
  const lightStyle = document.createElement("style");
  lightStyle.slot = "light-styles";
  lightStyle.innerHTML = prefixReplacer(lightStyles.toString());
  return { main: template, lightStyle };
}
class SkipContent extends SkapaElement {
  constructor() {
    super();
    const shadow = this.attachShadow({ mode: "open" });
    const { main, lightStyle } = this.getTemplates(generateTemplate);
    shadow.append(main.content.cloneNode(true));
    this.lightStyleNode = lightStyle.cloneNode(true);
  }
  connectedCallback() {
    super.connectedCallback();
    this.append(this.lightStyleNode);
    this.addEventListener("keydown", this.handleSpaceKey);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("keydown", this.handleSpaceKey);
  }
  handleSpaceKey(event) {
    if (event.target && event.key === " ") {
      const a = event.target.closest("a");
      if (a) {
        event.preventDefault();
        a.click();
      }
    }
  }
}
SkipContent.skapaTagName = "skip-content";
SkipContent.skapaDependencies = [];
SkipContent.observedAttributes = [];
export {
  SkipContent
};
